import axios from 'axios';
import { BASE_API_URL, HEADERS, CONTENT_TYPES } from '../../misc/constants'; // Import necessary constants

// Create an instance of Axios with the base URL
const axiosClient = axios.create({
  baseURL: BASE_API_URL, // Use the base API URL from constants
  headers: {
    [HEADERS.CONTENT_TYPE]: CONTENT_TYPES.APPLICATION_JSON, // Use headers and content type from constants
  },
  timeout: 10000, // Optional timeout
});

export default axiosClient;
